module.exports = {
    options: {
        language: '语言',
        zh: '简中',
        en: '英文',
        jp: '日本语',
        nodata: '暂无数据',
        addSucccess: '添加成功',
        succcess: '操作成功',
        more: '更多',
        recommend: '推荐',
        text1: '确定采用此酒店的报价',
        text2: '确定',
        text3: '取消',
        text4: '提示',  // reminder
        text5: '采用成功',  // reminder
        text6: '会议需求发布成功',  // reminder
        text7: '本会议室不支持摆放此桌型',  // reminder
        text8: "无",
        ok: "确定",
        cancel: "取消",
        tip: "提醒",
    },
    header: {
        home: '首页',
        meetingVenue: '会议场地',
        service: '配套服务',
        cyclopedia: 'CSR 项目中心',
        jion: '酒店入驻',
        abputUs: '关于我们',
        memberCenter: '会员首页',
        userInfo: '账户信息',
        applicationCenter: '商户中心',
        cooperative: '合作伙伴',
        supplier: '供应商入驻',
    },
    order: {
        all: '全部',
        submitted: '已提交',
        obtained: '获取方案中', // The plan has been obtained.
        communicate: '待沟通',
        reserved: '已预定',
        completed: '已完成',
        cancelled: '已取消',

        confirmed: '待确认',
        verify: '已核实',
        selected: '待入选',
        communication: '待沟通',
        bargain: '待成交',
        settle: '待结清',
        closedAccount: '已结清',
        process: '停止招标'
    },
    bottom_nav: {
        text1: '关于会之星',
        text2: '公司简介',
        text3: '联系我们',
        text4: '招贤纳士',
        text5: '与我们合作',
        text6: '酒店场地入驻',
        text7: '配套服务商入住',
        text8: '帮助中心',
        text9: '忘记密码',
        text10: '常见问题',
        text11: '商务合作',
        text12: '侵权投诉指引',
        text13: '微信客服',
        text14: '全国统一热线',
        text15: '在线咨询',
        text16: '苏州星添越数字技术有限公司',
        text17: '苏州市喜庆路99号斜杠广场4010',
        text18: '全球会议产业链酒店直采平台',
        text19: '苏ICP备2025174180号-1'
    },
    bottom_page: {
        text1: '定制化服务流程',
        text2: '1分钟发布会议需求',
        text3: '输入会议基本需求',
        text4: '10分钟会议顾问致电',
        text5: '专属顾问1v1跟进',
        text6: '30分钟获取会议方案',
        text7: '筛选方案智能匹配',
        text8: '预约看会议场地',
        text9: '实景化高度吻合',
        text10: '活动圆满落幕',
        text11: '全程服务保证质量',
    },
    citySelect: {
        text1: '请输入城市名',
    },
    aboutUs: {
        text1: '公司概况',
        text2: '会之星，致力于为企业提供一站式会务服务。 以高度整合的资源、专业的管理、贴心的服务。' +
            '助力客户，提升会议品质，创造会议价值，实现会议目标。',
        text3: '了解更多',
        text4: '发展历程',
        text5: '会之星的发展与成长，如同大地与根系，长河奔涌的浪潮下是无声的积累， 每一次破局的锋芒都藏着年轮里沉淀的光。',
        text6: '了解更多',
        text7: '投资者关系',
        text8: '在风险与机遇中，既要敏锐捕捉产业趋势的微光， 又需在周期波动中锚定长期价值的坐标。' +
            '每一次决策都是对认知的兑现，每一次等待都是与时间达成的契约。',
        text9: '了解更多',
        text10: '战略合作商',
        text11: '会之星全球酒店直采资源3000+，直连资源3W+，与全球知名酒店深度合作，足迹遍步各个核心。',
        text12: '了解更多',
        text13: '城市合伙人计划',
        text14: '在快速发展的商业浪潮中，我们诚挚邀请您加入“城市伙伴人计划”，携手开拓市场，共赢未来！作为城市合伙人，您将获得品牌支持，优质资源，专业培训及丰厚的回报机制，成为我们在当地市场的战略伙伴。',
        text15: '加入我们，以合伙之力，点燃城市商机！一座城，一个合伙人，一起成就无限可能！',
    },
    appCenter: {
        text1: '会之星全球会议产业链酒店直采平台',
        text2: '提升会议品质',
        text3: '创造会议价值',
        text4: '实现会议目标',
        text5: '酒店服务中心',
        text17: 'Hotel Service Center',  // 这里 -- en文件中用 中文
        text6: '酒店 会议中心 奥体中心 特殊场馆',
        text7: '客户服务中心',
        text18: 'Customer Service Center',  // 这里 -- en文件中用 中文
        text8: '一站式会议服务',
        text9: '配套服务中心',
        text19: 'Matching service Center',  // 这里 -- en文件中用 中文
        text10: '会议策划 设备租赁 广告物料 演艺机构 安保服务',
        text11: '旅游服务中心',
        text20: 'Tourism Service Center',  // 这里 -- en文件中用 中文
        text12: '旅游咨询 旅游规划 导游服务 培训拓展 培训 研学',
        text13: '票务服务中心',
        text21: 'Ticketing Service Center',  // 这里 -- en文件中用 中文
        text14: '行程规划 票务预定 退票改签 车辆服务 管家服务',
        text15: '婚庆服务中心',
        text22: 'Wedding Service Center',  // 这里 -- en文件中用 中文
        text16: '婚礼策划 婚礼执行 摄影摄像 造型服务 蜜月安排',
    },
    appCenter_service: {
        text1: '会务配套服务',
        text2: '高效简单解决会务需求',
        text3: '您的手机号码',
        text4: '手机验证码',
        text5: '获取验证码',
        text6: '免费预约申请',
        text7: '严选会务配套服务',
        text8: '精彩活动案例',
        text9: '咨询热线',
        text10: '在线咨询',
        more: '更多',

        text11: '旅游服务中心',
        text12: 'Tourism Service Center', // 这里 -- en文件中用 中文
        text13: '旅游咨询 旅游规划 导游服务',

        text14: '票务服务中心',
        text15: 'Ticketing Service Center', // 这里 -- en文件中用 中文
        text16: '行程规划 票务预定 退票改签',

        text17: '婚庆服务中心',
        text18: 'Wedding Service Center', // 这里 -- en文件中用 中文
        text19: '婚礼策划 婚礼执行 蜜月规划',

        text20: '创意策划',
        text21: '提供全流程会务策划方案',

        text22: '舞美搭建',
        text23: '专业团队，保驾活动落地',

        text24: '摄影摄像',
        text25: '直播剪辑，音视频处理',

        text26: '同声传译',
        text27: '准确、高效多语言信息传递',

        text29: '广告制作',
        text30: '提供最优物料，活动形象',

        text31: '演艺服务',
        text32: '为会务活动增添活力与亮点',

        text33: '车辆服务',
        text34: '提供安全、准时、舒适的服务',

        text35: '礼品定制',
        text36: '升华活动主题与活动形象',

        text37: '奥迪新车展览会',
        text38: '智利库里酒庄品酒会',
        text39: '中国钓鱼大师巡回赛',
        text40: '美奥口腔公益活动',

        text41: '供应商名称',
        text42: '国家',
        text43: '营业执照',
        text44: '用户名',
        text45: '密码',
        text49: '确认密码',
        text46: '手机号',
        text47: '验证码',
        text48: '邮箱',
        text50: '上传',
        text51: '请上传图片',
        text52: '发送验证码',
        text53: '提交',
        text54: '取消',
        text55: '请输入密码',
        text56: '请确认两次输入的密码一致',
        text57: '供应商入驻',
        text58: '请输入{value}',
        text59: '请输入正确的手机号',
        text60: '密码不能有中文',
        text61: '发送成功',
        text62: '已入驻，前往登录',
    },
    conferenceSpace: {
        all: '不限',
        text1: '请输入酒店、地标、商圈关键词',
        text2: '搜 索',
        text3: '酒店',
        text4: '地理位置',
        text5: '场地类型',
        text6: '酒店品牌',
        text7: '请输入集团或酒店名',
        text8: '容纳人数',
        text9: '会场面积',
        text10: '标间数量',
        text11: '风格特点',
        text12: '会场价格',
        text13: '酒店设施',

        text14: '会场',
        text15: '会场层高',
        text16: '会场条件',
        text17: '所在楼层',
        text18: '会场设施',
        text30: '地址',
        text31: '面积',
        text32: '层高',
        text33: '最多容纳人',
        text34: '灯下高度',
        text35: '长宽',
        text36: '楼层',

        text21: '首页',
        text22: '会议空间',
        text23: '客房',
        text24: '餐饮',
        text25: '配套设施',
        text26: '位置及周边',
        text27: '图集',
        text28: '活动案例',
        text29: '酒店促销',

        text37: '共为您找到',
        text38: '家酒店',
        text39: '个会议场所',
        text40: '数据验真',
        text41: '地址',
        text42: '会场面积',
        text43: '最多容纳',
        text44: '会场数量',
        text45: '客房数量',
        text46: '会场参考价',
        text47: '客房参考价',
        text48: '间',
        text49: '人',
        share: '分享',
    },
    conferenceSpace_active: {},
    conferenceSpace_canteen: {
        text1: '餐饮',
        text2: '共',
        text3: '餐厅',
        text4: '包厢',
        text5: '最大用餐面积',
        text6: '容纳用餐人数',
        text7: '面积',
        text8: '位于',
        text9: '层高',
        text10: '灯下高度',
        text11: '独立包间',
        text12: '个',
        text13: '总席位数',
        text14: '席',
        text15: '人均消费',
        text16: '营业时间',
    },
    conferenceSpace_facility: {
        text1: '配套设施',
        text2: '酒店服务设施'
    },
    conferenceSpace_home: {
        text1: '本酒店数据已由酒店与会之星平台共同验证',
        text2: '外观',
        text3: '大堂',
        text4: '配套',
        text5: '会议空间',
        text6: '客房',
        text7: '餐厅',
        text8: '酒店简介及特色',
        text9: '会议空间',
        text10: '间',
        text11: '客房',
        text12: '最大会场',
        text13: '餐厅',
        text14: '最多容纳',
        text15: '停车位',
        text16: '双床数量',
        text17: '大床数量',
        text18: '客房参考价',
        text19: '餐厅菜系',
        text20: '包间数量',
        text21: '酒店品牌',
        text22: '开业时间',
        text23: '最近装修',
        text24: '会议空间',
        text25: '会议空间',
        text26: '共',
        text27: '个',
        text28: '最大会场',
        text29: '最多容纳人数',
        text30: '人',
        text31: '会议室',
        text32: '面积',
        text33: '年',
        text34: '最多容纳',
        text35: '布局及容纳人数',
        text36: '参考价(随季节等因素变化)',
        text37: '客房',
        text38: '间',
        text39: '数量',
        text40: '上网方式',
        text41: '是否有窗',
        text42: '上网方式',
        text43: '无线上网',
        text44: '是',
        text45: '否',
        text46: '餐饮',
        text47: '包厢',
        text48: '最大用餐面积',
        text49: '容纳用餐人数',
        text50: '包间数',
        text51: '座位数',
        text52: '人均消费(随季节等因素变化)',
        text53: '长宽',
        text54: '层高',
        text55: '灯下高度',
        text56: '元',
    },
    conferenceSpace_imagePage: {},
    conferenceSpace_location: {
        text1: '位置及周边',
        text2: '复制地址',
        text3: '复制成功',
        text4: '复制失败',
    },
    conferenceSpace_promotion: {},
    conferenceSpace_room: {
        text1: '客房',
        text2: '间',
        text3: '起',
    },
    conferenceSpace_venue: {
        text1: '会议空间',
        text2: '共',
        text3: '个',
        text4: '最大会场',
        text5: '人',
        text6: '会议室',
        text7: '面积',
        text8: '布局及容纳人数',
        text9: '参考价(随季节等因素变化)',
        text10: '长宽',
        text11: '层高',
        text12: '灯下高度',
        text13: '最多容纳人数',
        text14: '最多容纳',
    },
    conferenceSpace_vanueDetail: {
        text1: '面积',
        text2: '长宽',
        text3: '层高',
        text4: '灯下高度',
        text5: '楼层',
        text6: '摆台及容量',
        text7: '剧院式',
        text8: '课桌式',
        text9: '中式宴会',
        text10: '西式宴会',
        text11: '酒会式',
        text12: '鱼骨/岛屿',
        text13: 'U/回字形',
        text14: '位置及周边',
        text15: '复制地址',
        text16: '董事会'
    },
    customer: {
        text1: '公司部门',
    },
    encyclopedia: {
        text1: '发布于',
    },
    loginInterface_loginInterface: {
        text1: '酒店及会议场地入驻攻略',
        text2: '入驻攻略视频',
        text3: '会之星销售助手：酒店销售接单及报价攻略',
        text4: '入驻会之星',
        text5: '接更多',
        text6: '会议订单',
        text7: '高效线上推单',
        text8: '平台人工审核，推单更精准',
        text9: '便携APP接单',
        text10: 'APP小程序极速接单',
        text11: '智能订单匹配',
        text12: '根据需求，快速匹配会议场地',
        text13: '专职管家服务',
        text14: '专职客服管家，1V1贴心服务',
    },
    loginInterface_enterForm: {
        text01: '获取验证码',
        text00: '重新发送',
        text000: '秒',
        text0: '请选择',
        text1: '验证码',
        text2: '请输入',
        text3: '所在酒店',
        text4: '您的职务',
        text5: '邮箱地址',
        text6: '名片信息',
        text7: '营业执照',
        text8: '姓名',
        text9: '性别',
        text10: '男',
        text11: '女',
        text12: '未知',
        text13: '用户名',
        text14: '手机号',
        text15: '设置密码',
        text16: '重复密码',
        text17: '入驻申请成功',
        text18: '点击跳转登录',
        text19: '返回',
        text20: '上一步',
        text200: '下一步',
        text21: '提交申请',
        text22: '会之星酒店注册提示',
        text23: '一、注册须知',
        text24: '注册会之星销售助手前，请确保您所在的酒店/场地已与会之星合作签约，且完成酒店/场地基本信息的录入。如未签约合作，您的注册信息将无法通过审核',
        text25: '二、注册流程',
        text26: '1.提交个人及职业实名信息',
        text27: '2.会之星审核信息并与酒店确认',
        text28: '3.开通账号',
        text29: '酒店/场地加盟请致电：',
        text30: '酒店信息',
        text31: '注册信息',
        text32: '提交申请',
        text33: '居民身份证',
        text34: '港澳居民来往内地通行证',
        text35: '台湾居民来往大陆通行证',
        text36: '外国人永久居留证',
        text37: '请输入姓名',
        text38: '请输入选择性别',
        text39: '请选择证件类型',
        text40: '请证件正面',
        text41: '请证件反面',
        text42: '请输入所在酒店',
        text43: '请输入职务',
        text44: '请上传名片',
        text45: '请上传营业执照',
        text46: '请输入英文或数字',
        text47: '请输入密码',
        text48: '请再次确认密码',
        text49: '请输入正确的手机号',
        text50: '请输入正确的邮箱',
        text05: '邮箱',
        text51: '确认密码与密码不一致，请修改后再提交!',
        text52: '提交成功!',
        text53: '发送成功!',
        text54: '发送失败，请稍后重试!',
        text55: '国家',
        text56: '请选择',
        text57: '国际区域',
        text58: '境内',
        text59: '境外',
        text60: '入驻类型',
        text61: '是否仅会场入驻',
    },
    matchingService: {
        text1: '在举办会议、展览或庆典活动时，场地搭建是至关重要的一环。我们提供专业的场地搭建服务，只需一个电话，我们的团队会亲临现场，进行详细的场地测量并提供专业建议。我们拥有丰富的设计和施工经验，能够根据客户的需求提供从设计到安装的一站式服务，确保每个环节都完美衔接。我们的服务不仅能为客户节省时间和成本，还能确保活动顺利进行，呈现出最佳效果。',
        text2: '会小通公司拥有多年的公关会议和活动服务经验，能够在完全满足设备要求的前提下，以低成本配置实现高效利用。在完美实现视觉效果的同时，为客户有效节省设备租赁和使用成本。在公关活动和商务会议中，音响设备尤为重要，因为它是现场所有声音来源的保障。会议服务专家会根据场地的不同和会议性质的差异，提供定制的音响解决方案。音响解决方案的关键因素包括活动场地的面积、场地高度、会议形式以及会议内容等方面。',
        text3: 'PAR灯',
        text4: '一般用于面光，可安装不同颜色的色片，配合现场演出等环节。亦称筒灯主要特性是射出较固定的光束，光束角度宽窄多种，光斑大小不能调整。',
        text5: '频闪灯',
        text6: '一般用于面光，可安装不同颜色的色片，配合现场演出等环节。',
        text7: '散光灯',
        text8: '多用于景物的大面积照明和天幕的照明，室外较多使用。',
        text9: '六眼灯',
        text10: '常用于舞台的大面积照明和观众区域的照明使用。',
        text11: '回光灯',
        text12: '舞台的大面积照明，常用语面光、测光及逆光等。',
        text13: '灯光控制台',
        text14: '可编程、储存信息，调控灯光变化，随同活动现场音乐即席配合演出。',
        text15: '扫描灯',
        text16: '品种、型号多样，花样丰富，多用于大型演出活动或演唱会。',
        text17: '激光灯',
        text18: '绚丽多彩的成像效果，可编程设计成像图案，多用于大型演出和大型。',
        text19: '成像灯',
        text20: '可多种形状成像，明亮度高。或称成型灯、椭球聚光灯。主要特性是如幻灯似的能将光斑切割成方、菱形、三角形等各种形状，或投射出所需各种图案花纹，功率也有1KW、2KW等可选择配置。',
        text21: '追光灯',
        text22: '活动用与人物的特写与跟踪使用，效果极佳。 主要在舞台全场黑暗的情况下用光柱突出演员或其他特殊效果，或对演员进行补光。追光灯可以变换各种不同的颜色，还有的追光灯可以打出不同的图案。特点是要人操纵，跟随演员移动。追光灯应用甚广，比如舞台剧、婚庆典礼、会场开幕式、闭幕式等场合都是常见的灯光效果用具。',
        text23: '电脑灯',
        text24: '多种花色、频闪等特殊效果。可安装LOGO片，适用于演出活动和各种效果配合。是一种高科技的专业级舞台灯光，由于其光源的特殊性、结构的复杂性和效果的多样性，舞台电脑灯大量运用在大型体育场馆、户外演出、剧院剧场及电视台演播室，成为舞台灯光应用的主流配置。',
        text25: '作为展示视觉效果和宣讲内容的核心设备，投影仪已成为公关会议和活动的标配。会小通的供应商具备多年的公关会议服务经验，了解不同类型和规模的会议对投影流明数的需求。他们根据各种品牌投影仪的色彩还原能力和特点，为客户量身推荐合适的设备，这正是会小通服务专家独到之处。LED显示屏适用于大型体育场馆、电视直播、展览场馆、年会、产品发布会和文艺演出等场所，可显示变化的数字、文字、图形和图像。它不仅适用于室内，还能在室外环境中使用，具有高亮度、低工作电压、低功耗、小型化、长寿命、耐冲击和性能稳定等优势。在向客户推荐大型LED屏幕时，会小通会根据会议类型和现场座位安排，推荐合适的点数和像素数，以满足活动需求并尽量为客户节省成本。',
        text26: '流明',
        text27: '人数',
        text28: '适用场合',
        text29: '较暗的环境，搭配100寸幕布最佳',
        text30: '人',
        text31: '较暗的会场，搭配100寸/120寸幕布效果最佳',
        text32: '较暗的会场，搭配150以下寸幕布效果最佳',
        text33: '低自然光的环境，搭配150寸幕布效果最佳',
        text34: '低自然光的环境，搭配150寸以上幕布效果最佳',
        text35: '低自然光的环境，根据要求可搭配定做大型号幕布',
        text36: '或大型演出',
        text37: '专业的摄影摄像服务是记录和传播精彩瞬间的关键。我们提供高质量的摄影摄像服务，拥有一支经验丰富、技术精湛的团队，能够捕捉活动中的每一个重要时刻。无论是高清摄像、照片拍摄还是后期制作，我们都能为您提供一站式服务，确保最终呈现的效果完美无缺。我们使用先进的摄影摄像设备，并根据活动的具体需求和场地条件，制定个性化的拍摄方案，为客户提供最佳的视觉记录和宣传素材。',
        text38: '专业DV数码摄像机',
        text39: '摇臂摄像机',
        text40: '索尼、松下等品牌，光学变焦12倍、16倍',
        text41: '美国占美全自动重型摇臂可调节距离为8米，10米，12米',
        text42: '索尼、松下等品牌，光学变焦12倍、16倍',
        text43: '美国占美全自动重型摇臂可调节距离为8米，10米，12米',
        text44: '直播服务已经成为会议、论坛、展览等各类线下活动的重要一环，现场直播可以放大线下活动的宣传效果。我们拥有经验丰富的服务团队，为您提供专业、高性价比的现场直播技术服务和解决方案，包括摄影摄像、导播、推流等一站式直播服务。我们使用先进的直播技术，根据客户的具体需求，制定个性化的直播方案和服务，并提供丰富的功能。我们提供的直播服务包括：视频包装直播、多平台推流、多机位视频直播、自定义布局、实时导播、直播字幕、直播文案、直播回放等，多平台推流支持直播到视频号，小红书、抖音等公域平台，同时也可以为客户提供私域直播解决方案。',
        text45: '专业的车辆服务是确保嘉宾和工作人员准时、安全抵达的重要保障。我们提供一流的车辆服务，包括豪华轿车、商务车、大巴等多种车型，满足不同规模和层次的需求。我们的司机团队经验丰富，熟悉城市道路和活动场地，能够提供准时、安全、舒适的接送服务。无论是接送贵宾、机场接送，还是活动期间的交通调度，我们都能为客户提供定制化的解决方案，确保活动顺利进行，提升客户和嘉宾的整体体验。',
        text46: '品牌',
        text47: '车型',
        text48: '载客',
        text49: '车辆配置',
        text50: '设计策划是确保活动成功的核心环节。我们提供全面的设计策划服务，从创意构想到细节执行，为客户打造独特且具有吸引力的活动方案。我们的团队由经验丰富的设计师和策划专家组成，能够根据客户的需求和活动目标，制定个性化的设计方案，包括视觉风格、布置布局、主题创意等。我们注重细节，确保每个设计元素都与活动主题完美契合，同时考虑到功能性和观众体验。我们的目标是通过专业的设计策划，提升活动的整体效果，为客户创造令人难忘的体验。',
        text51: '翻译服务是确保跨语言交流顺畅的重要保障。我们提供专业的翻译服务，包括同声传译、交替传译以及文件翻译，能够满足各种语言需求。我们的翻译团队由经验丰富的语言专家组成，具备丰富的行业知识和翻译经验，能够在各种活动场合中提供准确、高效的翻译支持。无论是国际会议、商务洽谈还是多语言展示，我们都能确保信息传达无误，帮助各方顺利沟通，提升活动的整体效果。',
        text52: '演员和节目是吸引观众和提升活动氛围的关键元素。我们提供高水平的演员节目服务，涵盖各种表演形式，包括舞蹈、音乐、戏剧、脱口秀等。我们的演员团队由专业艺术家组成，他们具有丰富的演出经验和卓越的表演技巧，能够根据活动主题和观众需求，量身定制精彩纷呈的节目。我们确保每一场演出都能完美呈现，带给观众独特而难忘的体验，为您的活动增添亮点和活力。',
        text53: '礼仪服务是提升活动专业形象和确保流程顺畅的关键。我们提供全面的礼仪服务，包括迎宾接待、引导服务、礼仪人员安排等，致力于为您的活动营造得体且高效的氛围。我们的礼仪团队由训练有素的专业人员组成，能够为嘉宾提供热情周到的服务，确保每一位宾客都能感受到尊重和关怀。无论是活动的签到、引导、还是现场协调，我们都能根据活动的具体需求，提供量身定制的礼仪服务，提升活动的整体品质和观众体验。',
        text54: '在举办年会或庆典活动时，精心的礼仪服务能够提升活动的庄重氛围和专业形象。我们的礼仪团队由训练有素的专业人员组成，能够以热情、周到的服务迎接每一位嘉宾，并协助处理各种突发情况。无论是大型年会、公司庆典还是私人聚会，我们都能根据活动规模和主题，提供量身定制的礼仪方案，帮助您打造一个难忘且高效的庆祝盛典。',
        text55: '在举办论坛活动时，优质的礼仪服务是确保活动顺利进行和提升专业形象的关键。无论是开幕式、圆桌讨论还是闭幕致辞，我们都能根据活动的需求和规模，提供量身定制的礼仪服务，确保论坛顺利进行并提升整体体验。',
        text56: '在举办品牌推广和发布会时，优质的礼仪服务能够有效提升活动的专业度和品牌形象。无论是品牌发布、产品展示还是媒体见面会，我们都能根据活动的具体需求和规模，提供量身定制的礼仪方案，帮助您成功塑造品牌形象并提升活动的整体效果。',
        text57: '精美的鲜花装饰是提升场地氛围和增添视觉美感的关键元素。我们提供专业的鲜花装饰服务，从花艺设计到现场布置，致力于为您的活动打造独特而优雅的环境。我们的花艺团队由经验丰富的设计师组成，他们能够根据活动主题、场地特点和客户需求，创作出令人惊艳的花艺作品。无论是舞台布置、迎宾区域还是桌面装饰，我们都能提供量身定制的方案，确保每一个细节都完美呈现，为您的活动增添色彩和品位。',
        text58: '高质量的印刷材料是展示信息和提升活动形象的关键。我们提供专业的印刷服务，包括会议手册、宣传册、名片、海报、横幅等各类印刷品。我们的团队拥有丰富的设计和印刷经验，使用先进的印刷设备和高质量的材料，确保每一份印刷品都具有卓越的视觉效果和触感。无论是品牌推广资料、活动指南还是宣传海报，我们都能根据客户的需求提供定制化的设计和印刷方案，帮助您以最佳的方式传达信息和提升活动的整体形象。',
        text59: '定制礼品是表达感谢和提升活动纪念价值的绝佳方式。我们提供专业的礼品定制服务，包括企业礼品、纪念品、奖品等各种类型的礼品。我们的团队具备丰富的设计经验和供应链资源，能够根据客户需求和活动主题，提供独特而具有纪念意义的定制礼品。无论是高端礼品盒、定制文具、品牌纪念品还是创意小物件，我们都能为您提供量身定制的解决方案，确保每一份礼品都能传达心意，提升品牌形象，并为您的活动增添亮点和意义。',
        text60: '根据客户的历史数据，会小通为客户提供更多的背景信息，以提高成单率并提升对客户的服务质量。',
        text61: '客户需求请拨打',

        text62: '场地搭建',
        text63: '音响灯光',
        text64: '视频投影',
        text65: '摄像摄影',
        text66: '直播服务',
        text67: '车辆服务',
        text68: '设计策划',
        text69: '翻译服务',
        text70: '演员节目',
        text71: '礼仪服务',
        text72: '鲜花装饰',
        text73: '印刷材料',
        text74: '礼品定制',

        text75: '宇通客车',
        text76: '大客',
        text77: '座',
        text78: '根据客户的历史数据，会小通为客户提供更多的背景信息，以提高成单率并提升对客户的服务质量。',
        text79: '中客',
        text80: '高背软椅，冷暖空调，高级音响，液晶电视，六碟VCD，大行李仓，ABS。',
        text81: '高背软椅，冷暖空调，高级音响，大行李仓，ABS。',
        text82: '高背软椅，冷暖空调，高级音响。',
    },
    userPage_address: {
        text1: '添加地址',
        text2: '姓名',
        text3: '手机号',
        text4: '地区',
        text5: '详细地址',
        text6: '请输入姓名',
        text7: '请输入手机号',
        text8: '请选择地区',
        text9: '请输入详细地址',
        text10: '取 消',
        text11: '确 定',
        text12: '操作',
        text13: '编辑',
        text14: '删除',
        deleteSuccess: '删除成功',
        updateSuccess: '编辑成功',
        addSucccess: '新增成功',
    },
    userPage_detail: {
        text1: '订单状态',
        text2: '会务专员',
        text3: '订单编号',
        text4: '下单时间',
        text5: '报价单列表',
        text6: '酒店名称',
        text7: '会议室',
        text8: '会场价格',
        text99: '用餐',
        text9: '用餐价格',
        text1010: '住宿房间',
        text10: '住宿价格',
        text11: '酒店备注',
        text12: '操作',
        text13: '需求信息',
        text14: '活动城市',
        text15: '举办时间',
        text16: '活动人数',
        text17: '活动预算',
        text18: '活动类型',
        text19: '活动需求',
        text20: '个人信息',
        text21: '联系人',
        text22: '手机号码',
        text23: '公司名称',

        text24: '会场全天价格',
        text25: '会场半天价格',
        text26: 'Led宽',
        text27: 'Led高',
        text28: '场地搭建费用',
        text29: '场地搭建描述',
        text30: '用餐类型',
        text31: '用餐价格',
        text32: '已采用',
        text33: '未采用',
        text34: '房间类型',
        text35: '房间价格',
        text36: '采用',
    },
    userPage_home: {
        text0: '当前积分',
        text1: '修改资料',
        text2: '积分商城',
        text3: '积分订单',
        text4: '客户地址',
        text5: '暂无订单',
        text6: '订单号',
        text7: '发布于',
        text8: '预算',
        text9: '人数',
        text10: '活动城市',
        text11: '活动类型',
        text12: '活动日期',
        text13: '活动需求',
        text14: '等待获取场地方案（包含档期报价）',
        text15: '顾问已邀请酒店报价，25分钟左右为您严选 3-6个场地方案',
        text16: '查看已报价列表及详细信息',

        text17: '我的信息',
        text18: '个人信息',
        text19: '地址管理',
        text20: '我的订单',
        text21: '酒店订单',
        text22: '配套设施订单',
        text23: '积分商城',
        text24: '积分兑换',
        text25: '积分订单',
        text26: '积分规则',
        text27: '积分明细',
        text28: '售后服务',
        text29: '发票开具',
        text30: '确定退出登录？',
        text31: '退出登录',
    },
    userPage_infoPage: {
        text1: '您的信息',
        text2: '姓名',
        text3: '请输入姓名',
        text4: '性别',
        text5: '请选择性别',
        text6: '男',
        text7: '女',
        text8: '未知',
        text9: '生日',
        text10: '请选择生日',
        text11: '电子邮件',
        text12: '请输入电子邮件',
        text13: '请输入QQ号码',
        text14: '微信号',
        text15: '请输入微信号',
        text16: '企业名称',
        text17: '请输入企业名称',
        text18: '所属部门',
        text19: '请选择所属部门',
        text20: '您的职位',
        text21: '请选择职位',
        text22: '提 交'
    },
    userPage_login: {
        text1: '会之星',
        text2: '客户管理系统',
        text3: '一站式会务服务平台',
        text4: '您好!',
        text5: '欢迎登录会之星客户管理系统',
        text6: '请输入手机号',
        text7: '请输入验证码',
        text8: '登 录',
        text9: '发送验证码',
        text10: '请先输入手机号并获取验证码',
        text11: '重新发送',
    },
    userPage_shop: {
        text1: '积分价格',
        text2: '全部',
    },
    userPage_shopDetail: {
        text1: '积分价格',
        text2: '剩余数量',
        text3: '下单数量',
        text4: '描述文字',
        text5: '选择地址',
        text6: '请选择',
        text7: '验证码',
        text8: '购 买',
        text9: '发送验证码',
        text10: '下单成功',

        text11: '请选择地址',
        text12: '请输入验证码',
        text13: '是否确定下单',
        text14: '取消按钮被点击',
        text15: '点击确定，将给您的手机号（{phoneNumber}）发送验证码，是否发送？',
        text16: '当前积分不足'
    },
    userPage_waresOrder: {
        text1: '商品名',
        text2: '类型',
        text3: '订单号',
        text4: '手机号',
        text5: '地址',
    },
    Index_page: {
        text1: '发布会议需求',
        text2: '会议顾问1对1帮找场地、查档期、询底价',
        text03: '是否为国际订单？',
        text3: '您要在哪里办活动？',
        text4: '试试搜索：指南',
        text5: '办一场什么活动？',
        text6: '举办活动日期',
        text7: '选择日期',
        text8: '活动时长',
        text9: '参加人数',
        text10: '大致预算',
        text11: '您的项目需求',
        text12: '需要广告策划、舞美搭建等其他配套服务',
        text13: '免费匹配场地',
        text14: '1分钟',
        text15: '发布会议需求',
        text16: '10分钟',
        text17: '会议顾问致电',
        text18: '30分钟',
        text19: '获得会议方案',
        text20: '返回修改需求',
        text21: '请确认您的活动',
        text22: '您要在',
        text23: '办一场',
        text24: '开始时间在',
        text25: '为期',
        text26: '人数在',
        text27: '预算为',
        text28: '包含',
        text29: '等等活动需求',
        text30: '请输入您的手机号，用于接受场地方案及报价',
        text31: '获取验证码',
        text32: '免费获取场地报价、档期',
        text33: '提交会议需求即视为同意',
        text34: '《会之星用户协议》',
        text35: '《隐私保护政策》',
        text36: '使用会之星的初衷',
        text37: '高效匹配理想的场地',
        text38: '直连全球酒店和会议特色场地，一键发布会议信息，快速获得报价',
        text39: '系统智能搜索询价，场地性价比更高',
        text40: '平台会议场地智能比价，优惠力度30%+',
        text41: '助力会议设备配套服务',
        text42: '平台一站搞定舞美、策划、搭建、物料、用车、购票等',
        text43: '用户免费注册使用平台',
        text44: '线上线下会议顾问一对一服务',
        text45: '线下会务服务更专业',
        text46: '平台线上匹配场地，线下专业服务更贴心',
        text47: '全国办会好去处',
        text48: '精选会议场地',
        text49: '会场面积',
        text50: '热门会议酒店',
        text51: '最大会场面积',
        text52: '城市周边办会好去处',
    },
    activityDetail: {
        text1: '订房说明', // 活动说明标题
        text2: '展开', // 展开按钮文案
        text3: '收起', // 收起按钮文案
        text4: '会之星提供技术支持', // 底部技术支持文字
        text5: '未找到活动信息，请从正确的入口进入', // 缺少活动ID提示
        text6: '加载中...', // 加载中文案
        text7: '点击重试', // 重试按钮文案
        text8: '活动信息加载失败', // 加载失败文案
    }
}